export default [
  {
    path: '/ruleEngine/sene',
    name: 'sene',
    component: () => import('@/views/ruleEngine/SceneLink.vue'),
    meta: { title: '场景联动' }
  },
  {
    path: '/ruleEngine/sene/detaile',
    name: 'sene-detaile',
    component: () => import('@/views/ruleEngine/ruleDetaile.vue'),
    meta: { title: '场景联动-规则详情' }
  },
  {
    path: '/ruleEngine/sene/log',
    name: 'sene-log',
    component: () => import('@/views/ruleEngine/operationLog.vue'),
    meta: { title: '场景联动-操作日志' }
  }
]
